import { Price, PriceHistory, ProductCondition } from 'src/types';
import {
  SortOptionEnum,
  PriceDisplayEnum,
} from 'src/components/price-list/types';
import { getGAFeatured, getGAPrice } from './ga';
import {
  ProductActionType,
  ProductPriceClickStatus,
  ProductHeaderClickEventType,
  ProductPriceClickFunc,
} from './types';

// NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
// reflected in react/middlewares/out.js pre click for tracking clicks before JS bundle

export const productPriceClick: ProductPriceClickFunc = (
  productId: number | null,
  price: Price | PriceHistory | number | undefined | null,
  featured: boolean,
  status: ProductPriceClickStatus,
  isAlternative?: boolean | undefined, // This is a much better representation than "status" which is very unclear and hard to use - However, we should not have both
  context?: string // Means to represent in which context the click was made, "Offerlist", "ProductCollection", etc
) => {
  return {
    type: ProductActionType.PRODUCT_PRICE_CLICK,
    productId,
    price: getGAPrice(price, status),
    featured: getGAFeatured(featured),
    status,
    isAlternative,
    context,
  };
};

export const productNavigation = (action: string, index: number) => ({
  type: ProductActionType.PRODUCT_NAVIGATION,
  action,
  index,
});

export const productClickOutBounce = (
  productId: number,
  priceId: string | undefined | null
) => ({
  type: ProductActionType.PRODUCT_PRICE_CLICK_BOUNCE,
  productId,
  priceId,
});

export const headerClickEvent = (event: ProductHeaderClickEventType) => ({
  type: ProductActionType.PRODUCT_HEADER_CLICK,
  event,
});

export const setSelectedLegacyVariants = (variants: number[] | null) => ({
  type: ProductActionType.PRODUCT_LEGACY_VARIANT_SELECTED,
  variants,
});

export const setSelectedSizeVariants = (variantSizes: string[] | null) => ({
  type: ProductActionType.PRODUCT_SIZE_VARIANT_SELECTED,
  variantSizes,
});

export const setSelectedCondition = (condition: ProductCondition) => ({
  type: ProductActionType.PRODUCT_CONDITION_SELECTED,
  condition,
});

export const priceShippingDisplay = (priceDisplay: PriceDisplayEnum) => ({
  type: ProductActionType.PRICE_SHIPPING_DISPLAY,
  priceDisplay,
});

export const offerSorting = (sorting: SortOptionEnum) => ({
  type: ProductActionType.OFFER_SORTING,
  sorting,
});
